/*eslint-disable*/
import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { NavLink, useParams } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Pagination from "@material-ui/lab/Pagination";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";

// @material-ui/icons
import CloseIcon from "@material-ui/icons/Close";
import AssignmentIcon from "@material-ui/icons/Assignment";
import SearchIcon from "@material-ui/icons/Search";
import AlertIcon from "@material-ui/icons/AddAlert";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import FaceIcon from "@material-ui/icons/Face";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import InputIcon from "@material-ui/icons/Input";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Table from "components/Table/Table.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import CustomTabs from "components/CustomTabs/CustomTabs.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import i18n from "components/Translation/Translate.js";
import { withNamespaces } from "react-i18next";
import { PostData } from "services/Request";
import * as Func from "services/Function";

import styles from "assets/jss/main-style.js";
import PurchaseOrder from "./PurchaseOrder";

/* ========== ZONE Variable ========== */
const useStyles = makeStyles(styles);

const initAttr = {
  code: "",
  id: "",
  name: "",
  balance: "0.00",
  count_order: "0",
  count_shipping: "0",
  count_invoice: "0",
  enable: "Y",
};

const initFind = {
  search: "",
  order_by: "tb.name",
  order_sort: "asc",
  page: 1,
  perPage: 30,
  pageTotal: 0,
  member: "ALL",
  member_name: "",
  status: "ALL",
};

/* ========== ZONE Function ========== */
function PurchaseSupplier({ t }) {
  const mod = "purchasesupplier";
  const prefix = "member";
  const classes = useStyles();

  const initHeader = [
    { code: "tb.code", name: `attr.code` },
    { code: "tb.name", name: "field.supplier", order: "asc" },
    { code: "order_balance", name: "field.po_not_received", sort: false },
    { code: "tb.balance", name: "field.outstanding", sort: false },
    { code: "tb.credit", name: "field.po_not_paid" },
    { code: "so.date_due", name: "field.bill_due", sort: false },
    { code: "count_receipt", name: "field.paid_no_receipt", sort: false },
  ];
  const alignValue = [0, 2, 3, 4, 5, 6];
  const alignItem = [
    classes.center,
    classes.center,
    classes.right,
    classes.right,
    classes.right,
    classes.right,
    classes.right,
  ];
  const cboPerPage = [
    { id: 10, name: "element.show_10_record" },
    { id: 30, name: "element.show_30_record" },
    { id: 100, name: "element.show_100_record" },
  ];

  const txtMember = useRef(null);
  const txtSearch = useRef(null);
  const app = useSelector((state) => state.appState);
  const { id } = useParams();
  const [pageTotal, setPageTotal] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [record, setRecord] = useState([]);
  const [attr, setAttr] = useState(initAttr);
  const [find, setFind] = useState(initFind);
  const [header, setHeader] = useState(initHeader);
  const [alert, setAlert] = useState(null);
  const [notify, setNotify] = useState(null);
  const [tab, setTab] = useState(0);
  const [modalCustomer, setModalCustomer] = useState(false);
  const [loading, setLoading] = useState(false);
  const [invoiceId, setInvoiceId] = useState("");
  const [memberList, setMemberList] = useState([]);
  const [cboStatus, setCboStatus] = useState([]);
  const [dateRecord, setDateRecord] = useState(Func.dateFormat(new Date()));

  useEffect(() => {
    i18n.changeLanguage(app.lang);
    init();
  }, [id]);

  const init = () => {
    PostData(mod, "init", {
      token: app.token,
      lang: app.lang,
    }).then((result) => {
      if (result.status === "OK") {
        if (id === undefined) {
          setCboStatus(result.stat);
          view(find);
        } else {
          setTab(0);
          open();
        }
      } else {
        Func.exitApp();
      }
    });
  };

  const search = (e) => {
    e.preventDefault();

    view({ ...find, search: txtSearch.current.value, page: 1 });
    setFind({ ...find, search: txtSearch.current.value, page: 1 });
  };

  const changeTab = (event, value) => {
    if (value == 2) setInvoiceId("");
    setTab(value);
  };

  const changeDate = (date) => {
    setDateRecord(date);
    setTab(1);
  };

  const changeReceipt = (date) => {
    setDateRecord(date);
    setTab(5);
  };

  const openInvoice = () => {
    setLoading(true);
    setAttr(initAttr);

    PostData(mod, "open", {
      token: app.token,
      lang: app.lang,
      code: id,
    }).then((result) => {
      setLoading(false);
      if (result.status === "OK") {
        setAttr(result.data);

        setLoading(false);
      }
    });
  };

  const view = (data) => {
    setLoading(true);
    PostData(mod, "view", {
      token: app.token,
      lang: app.lang,
      search: data.search,
      page: data.page,
      per_page: data.perPage,
      orderby: data.order_by,
      asc: data.order_sort,
      member: data.member,
      status: data.status,
    }).then((result) => {
      if (result.status === "OK") {
        setRecord([]);

        result.data.map((item, i) => {
          setRecord((record) => [
            ...record,
            [
              item.code,
              btnOpen(item),
              displayQuantity(item.wait_recieve, item.date_po),
              displayNumber(item.total_invoice),
              displayQuantity(item.count_invoice, item.date_invoice),
              displayNumber(item.count_due, 0),
              displayNumber(item.count_receipt, 0),
            ],
          ]);
        });

        setPageTotal(result.total_pages);
        setPageNo(result.page);
      }
      setLoading(false);
    });
  };

  const btnOpen = (item) => {
    return (
      <NavLink to={`/admin/${mod}/${item.code}`}>
        <Button color={item.count_po * 1 > 1 ? "danger" : "primary"} simple>
          {item.name}
        </Button>
      </NavLink>
    );
  };

  const open = () => {
    setLoading(true);
    setAttr(initAttr);

    PostData(mod, "open", {
      token: app.token,
      lang: app.lang,
      code: id,
    }).then((result) => {
      setLoading(false);
      if (result.status === "OK") {
        setAttr(result.data);

        setLoading(false);
      }
    });
  };

  const searchOpen = () => {
    setModalCustomer(true);

    setTimeout(function () {
      txtMember.current.select();
    }, 500);
  };

  const searchCustomer = (e) => {
    e.preventDefault();

    setMemberList([]);

    if (txtMember.current.value == "") return;

    PostData(mod, "membersearch", {
      token: app.token,
      lang: app.lang,
      search: txtMember.current.value,
    }).then((result) => {
      if (result.status === "OK") {
        result.data.map((item, i) => {
          setMemberList((memberList) => [
            ...memberList,
            [textName(item), displayBalance(item.balance)],
          ]);
        });
      }
    });
  };

  const displayBalance = (balance) => {
    if (balance < 0)
      return (
        <code className="color-danger">{Func.numberDisplay(balance)}</code>
      );
    else if (balance > 0)
      return (
        <code className="color-success">{Func.numberDisplay(balance)}</code>
      );
    else return "";
  };

  const displayNumber = (number, p = 2) => {
    if (number < 0) return Func.numberDisplay(number, p);
    else if (number > 0) return Func.numberDisplay(number, p);
    else return "-";
  };

  const displayQuantity = (qty, dt) => {
    if (qty < 0)
      return (
        <span>
          <code className="color-danger">{Func.numberDisplay(qty, 0)}</code>(
          {dt})
        </span>
      );
    else if (qty > 0)
      return (
        <span>
          <code className="color-danger">{Func.numberDisplay(qty, 0)}</code> (
          {Func.dateDisplay(dt)})
        </span>
      );
    else return "";
  };

  const textName = (item) => {
    return (
      <Button
        simple
        color="github"
        onClick={() => window.location.replace(`/admin/${mod}/${item.code}`)}
      >
        <i className="fas fa-user-edit" /> {item.name}
      </Button>
    );
  };

  const showNotify = (msg, color) => {
    setNotify(
      <Snackbar
        place="tr"
        color={color}
        icon={AlertIcon}
        message={msg}
        open={true}
        closeNotification={() => setNotify(null)}
        close
      />
    );

    setTimeout(function () {
      setNotify(null);
    }, 3000);
  };

  const btn = (item) => {
    return (
      <NavLink to={`/admin/${mod}/${item.code}`}>
        <Button color="success" className={classes.actionButton} size="sm">
          {t(`element.open`)} <InputIcon />
        </Button>
      </NavLink>
    );
  };

  const renderHeader = (data) => {
    let icon = <i className="fas fa-sort"></i>;
    if (data.order === "desc") {
      icon = <i className="fad fa-sort-up"></i>;
    } else if (data.order === "asc") {
      icon = <i className="fad fa-sort-down"></i>;
    } else {
      icon = <i className="fad fa-sort"></i>;
    }

    if (data.sort === undefined || data.sort)
      return (
        <div
          onClick={() => {
            let tmp = [];
            header.map((item, i) => {
              if (data.code === item.code) {
                const ordersort = item.order === "asc" ? "desc" : "asc";
                view({ ...find, order_sort: ordersort, order_by: data.code });
                setFind({
                  ...find,
                  order_sort: ordersort,
                  order_by: data.code,
                });
                tmp[i] = {
                  code: item.code,
                  name: item.name,
                  order: ordersort,
                  sort: item.sort,
                };
              } else {
                tmp[i] = {
                  code: item.code,
                  name: item.name,
                  order: "",
                  sort: item.sort,
                };
              }
            });

            setHeader(tmp);
          }}
          style={{ cursor: "pointer" }}
        >
          {t(data.name)} {icon}
        </div>
      );
    else return <div>{t(data.name)}</div>;
  };

  const renderViewList = () => {
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <AssignmentIcon />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>{t("element.viewlist")}</h4>
            </CardHeader>
            <CardBody>
              <GridContainer className="viewlist">
                <GridItem xs={12} sm={6} md={6}>
                  <form noValidate onSubmit={search}>
                    <TextField
                      fullWidth
                      InputProps={{
                        inputRef: txtSearch,
                        startAdornment: (
                          <InputAdornment position="start">
                            {t("field.customer_label")}
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                        autoComplete: "off",
                      }}
                    />
                  </form>
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <FormControl fullWidth>
                    <Select
                      value={find.status}
                      onChange={(e) => {
                        setFind({ ...find, status: e.target.value, page: 1 });
                        view({ ...find, status: e.target.value, page: 1 });
                      }}
                    >
                      <MenuItem
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                        value="ALL"
                      >
                        {t("element.check_status")}
                      </MenuItem>
                      {cboStatus.map((item) => (
                        <MenuItem
                          key={item.code}
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value={item.code}
                        >
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12}>
                  <Table
                    striped
                    hover
                    tableHead={[
                      renderHeader(header[0]),
                      renderHeader(header[1]),
                      renderHeader(header[2]),
                      renderHeader(header[3]),
                      renderHeader(header[4]),
                      renderHeader(header[5]),
                      renderHeader(header[6]),
                    ]}
                    tableData={record}
                    customHeadClassesForCells={alignValue}
                    customHeadCellClasses={alignItem}
                    customClassesForCells={alignValue}
                    customCellClasses={alignItem}
                    coloredColls={[]}
                    colorsColls={[]}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={6} md={4} lg={3}>
                  <FormControl fullWidth className={classes.selectFormControl}>
                    <InputLabel className={classes.selectLabel}></InputLabel>
                    <Select
                      value={find.perPage}
                      onChange={(e) => {
                        view({
                          ...find,
                          page: 1,
                          perPage: e.target.value,
                          page: 1,
                        });
                        setFind({
                          ...find,
                          page: 1,
                          perPage: e.target.value,
                          page: 1,
                        });
                      }}
                    >
                      {cboPerPage &&
                        cboPerPage.map((item) => (
                          <MenuItem
                            key={item.id}
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value={item.id}
                          >
                            {t(item.name)}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </GridItem>
                <GridItem
                  xs={12}
                  sm={6}
                  md={8}
                  lg={9}
                  className={classes.right}
                >
                  <Pagination
                    style={{ float: "right", marginTop: "20px" }}
                    count={pageTotal}
                    showFirstButton
                    showLastButton
                    page={pageNo}
                    onChange={(e, p) => {
                      view({ ...find, page: p });
                      setFind({ ...find, page: p });
                    }}
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  };

  const renderEdit = () => {
    return (
      <GridContainer>
        <GridItem xs={12}>{renderDetail()}</GridItem>
        <GridItem xs={12}>
          <CustomTabs
            headerColor="primary"
            value={tab}
            changeValue={changeTab}
            tabs={[
              {
                tabName: t("field.po"),
                tabIcon: MonetizationOnIcon,
                tabContent: (
                  <PurchaseOrder
                    changeDate={changeDate}
                    changeReceipt={changeReceipt}
                    openInvoice={openInvoice}
                  />
                ),
              },
            ]}
          />
        </GridItem>
      </GridContainer>
    );
  };

  const renderDetail = () => {
    return (
      <GridContainer>
        <GridItem xs={12} sm={6} md={3} lg={3}>
          <Button color="info" size="lg" block onClick={() => searchOpen()}>
            <FaceIcon /> {attr.name}
          </Button>
        </GridItem>
        <GridItem xs={12} sm={6} md={3} lg={3}></GridItem>
        <GridItem xs={12} sm={6} md={3} lg={3}></GridItem>
        <GridItem xs={12} sm={6} md={3} lg={3}>
          <NavLink to={`/admin/${mod}`} className={classes.colorWarning}>
            <Button color="warning" size="lg" block>
              <ArrowBackIcon /> {t("element.back")}
            </Button>
          </NavLink>
        </GridItem>
      </GridContainer>
    );
  };

  const renderModalCustomer = () => {
    return (
      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal,
        }}
        open={modalCustomer}
        maxWidth={"sm"}
        fullWidth
        keepMounted
        onClose={() => setModalCustomer(false)}
        aria-labelledby="modal-customer-title"
        aria-describedby="modal-customer-description"
      >
        <DialogTitle
          id="modal-customer-title"
          disableTypography
          className={classes.modalHeader}
        >
          <Button
            justIcon
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="transparent"
            onClick={() => setModalCustomer(false)}
          >
            <CloseIcon className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>
            {t(`${prefix}.name`)} : {attr.name}
          </h4>
        </DialogTitle>
        <DialogContent id="modal-customer" className={classes.modalBody}>
          <GridContainer>
            <GridItem xs={12}>
              <form noValidate onSubmit={searchCustomer}>
                <CustomInput
                  labelText={t("element.search")}
                  id="search"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    inputRef: txtMember,
                    onChange: (e) => {},
                    endAdornment: (
                      <InputAdornment position="end">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                    autoComplete: "off",
                  }}
                />
              </form>
            </GridItem>
            <GridItem xs={12}>
              <Table
                striped
                hover
                tableData={memberList}
                customHeadClassesForCells={[1]}
                customHeadCellClasses={[classes.right]}
                customClassesForCells={[1]}
                customCellClasses={[classes.right]}
                coloredColls={[]}
                colorsColls={[]}
              />
            </GridItem>
          </GridContainer>
        </DialogContent>
      </Dialog>
    );
  };

  const renderLoading = () => {
    return (
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  };

  const renderPage = () => {
    if (id === undefined) {
      return renderViewList();
    } else {
      return renderEdit();
    }
  };

  /* ========== ZONE Render ========== */
  return (
    <div>
      {renderPage()}
      {renderModalCustomer()}
      {renderLoading()}
      {alert}
      {notify}
    </div>
  );
}

export default withNamespaces()(PurchaseSupplier);
